import { Inject, Injectable } from "@angular/core";
import { set as _set } from "lodash";
import { RequestService } from "../graphql/request.service";
import { IStatePropMap, StateToMapConfig } from "./state-to-request-map.config";

export interface RequestMethods {
    getList?: () => any;
    getDetail?: () => any;
    mutate?: () => any;
    postAttachments?: () => any;
    delete?: () => any;
    getUserPermission?: () => any;
}

export interface RequestMap {
    [stateProp: string]: RequestMethods;
}

const REQUEST_MAP: RequestMap = {};

@Injectable()
export class ReduxRequestsMap {
    constructor(
        @Inject(RequestService) private requestServices,
        @Inject(StateToMapConfig) public statePropMaps,
    ) {
        this.requestServices.forEach((service) => {
            this.statePropMaps.forEach((statePropMap) => {
                Object.keys(statePropMap).forEach((stateProp) => {
                    Object.keys(statePropMap[stateProp]).forEach((methodType) => {
                        const method = statePropMap[stateProp][methodType];
                        if (service[method] !== undefined) {
                            _set(REQUEST_MAP, [stateProp, methodType], service[method].bind(service));
                        }
                    });
                });
            });
        });
    }

    public within(stateProp): RequestMethods | any {
        let method = REQUEST_MAP[stateProp];
        let existingMatch = "";
        if (!method) {
            Object.keys(REQUEST_MAP).forEach((prop) => {
                const currentMatchResult = stateProp.match(new RegExp(prop));
                let currentMatch = "";
                if (currentMatchResult !== null) {
                    currentMatch = currentMatchResult[0];
                }
                if (currentMatch.length > existingMatch.length) {
                    method = REQUEST_MAP[prop];
                    existingMatch = currentMatch;
                }
            });
        }
        return method;
    }
}

export function buildRequestMapConfig(map: IStatePropMap, requestProviders) {
    return [
        ReduxRequestsMap,
        ...requestProviders,
        {
            provide: StateToMapConfig,
            useValue: map,
            multi: true,
        },
    ];
}
